// extracted by mini-css-extract-plugin
export default {"prod":"AboutContent_prod__r2HWZ","prod_img":"AboutContent_prod_img__uwXtL"};